/**
 *
 * ButtonsFooter
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
import { Button } from "antd"
/* eslint-disable react/prefer-stateless-function */
class ButtonsFooter extends React.Component {
  render() {
    const { buttons, style } = this.props
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
      const combinedStyle = {
        ...(hasFreshchat ? { marginRight: "88px" } : {}),
      }
    return (
      <div className= "ButtonsFooterComponent" style={{ ...(typeof window.Intercom !== "undefined" &&
        window.self === window.top && {
        paddingRight: "0px"}) }}  >
        <div className="ButtonsFooterComponent-buttons" style={combinedStyle}>
          {buttons &&
            buttons.map((b, bi) => (
              <Button
                key={bi}
                type={b.type}
                disabled={b.disabled}
                loading={b.loading}
                onClick={() => b.onClick(true)}>
                {b.content}
              </Button>
            ))}
        </div>
      </div>
    )
  }
}
//
ButtonsFooter.defaultProps = { style: {} }

export default ButtonsFooter
